"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Image = /*#__PURE__*/function (_React$Component) {
  _inherits(Image, _React$Component);

  var _super = _createSuper(Image);

  function Image() {
    _classCallCheck(this, Image);

    return _super.apply(this, arguments);
  }

  _createClass(Image, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          icon = _this$props.icon;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "bg-".concat(color, "-light round-full color-").concat(color, " flex-parent flex-parent--center-main flex-parent--center-cross"),
        style: {
          width: 50,
          height: 50
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: icon,
        size: 40
      }));
    }
  }]);

  return Image;
}(_react.default.Component);

Image.propTypes = {
  color: _propTypes.default.oneOf(['gray', 'orange', 'red', 'green', 'purple', 'pink', 'yellow', 'blue']).isRequired,
  icon: _propTypes.default.string
};
var themes = {
  default: {
    image: /*#__PURE__*/_react.default.createElement(Image, {
      icon: "book",
      color: "gray"
    }),
    label: 'Note',
    icon: 'book',
    styles: {
      background: '#f4f7fb',
      color: '#425870'
    }
  },
  warning: {
    image: /*#__PURE__*/_react.default.createElement(Image, {
      icon: "alert",
      color: "orange"
    }),
    label: 'Warning',
    icon: 'alert',
    styles: {
      background: '#feefe2',
      color: '#78471c',
      borderColor: '#ba6e2c'
    }
  },
  error: {
    image: /*#__PURE__*/_react.default.createElement(Image, {
      icon: "alert",
      color: "red"
    }),
    label: 'Error',
    icon: 'alert',
    styles: {
      background: '#fbe5e5',
      color: '#9b3134'
    }
  },
  beta: {
    image: /*#__PURE__*/_react.default.createElement(Image, {
      icon: "lightning",
      color: "blue"
    }),
    label: 'Beta',
    icon: 'lightning',
    tooltipText: 'This feature is in public beta and is subject to changes.',
    styles: {
      background: '#f1f3fd',
      color: '#0c248d',
      borderColor: '#0428c8'
    }
  },
  new: {
    image: /*#__PURE__*/_react.default.createElement(Image, {
      icon: "plus",
      color: "green"
    }),
    label: 'New!',
    icon: 'plus',
    tooltipText: 'This feature was released recently.',
    styles: {
      background: '#e8f5ee',
      color: '#15603d',
      borderColor: '#378645'
    }
  },
  download: {
    image: /*#__PURE__*/_react.default.createElement(Image, {
      icon: "arrow-down",
      color: "purple"
    }),
    label: 'Download',
    icon: 'arrow-down',
    styles: {
      background: '#f2effa',
      color: '#452f92'
    }
  },
  fundamentals: {
    label: 'Fundamentals',
    icon: 'bookmark',
    tooltipText: 'The concepts described here are fundamental to using this product.',
    styles: {
      background: '#fff0f7',
      color: '#cf1c61',
      borderColor: '#fd8ac0'
    }
  }
};
/* duplicate themes */

themes.legacy = _extends({}, themes.warning);
themes.legacy.label = 'Legacy';
themes.legacy.tooltipText = 'This feature is no longer in active development.';
var _default = themes;
exports.default = _default;